<template>
    <v-container fluid class="login-form-container login-container fill-height justify-center">
      <v-row justify="center"  :class="needToResize ? 'flex-column-reverse align-center' : ''">
        <v-col sm="8" md="7" lg="8" xl="6">
          <v-card>
            <v-card-title class="justify-center">
              Вітаємо в особистому веб-кабінеті користувача!
            </v-card-title>
            <!--<v-card-text class="text--primary justify-center">
              <v-img
                max-height="200"
                max-width="250"
                src=""
              ></v-img>
            </v-card-text>-->
            <v-card-text class="text--primary">
            <div v-for="line in loginDopText" :key="line">
              {{line}}
            </div>
            </v-card-text>
          <v-card-text class="text--primary">
          <img :src="glFirmLogoImg" class="pl-3 full-logo" />
          </v-card-text>
          
          </v-card>

        </v-col>
        <v-col cols="10" sm="7" md="5" lg="4" xl="4">
          <v-card>
            <v-row class="pa-5" align="center">
              <v-col class="d-flex flex-column">
                <h3 class="mb-4">{{ $t('login.title') }}</h3>
                <p>{{ $t('login.welcome') }}</p>

                <v-form>
                  <v-text-field
                    v-model="login"
                    :label="$t('login.placeholder')"
                    outlined
                    name="login"
                    type="text"
                    autocomplete="username"
                    class="body-2"
                    @keyup.enter="loginMethod"
                  >
                    <template #prepend-inner>
                      <v-icon small class="pt-1 pr-2">fas fa-user</v-icon>
                    </template>
                  </v-text-field>

                  <v-text-field
                    v-model="password"
                    :label="$t('login.password')"
                    outlined
                    name="password"
                    type="password"
                    autocomplete="current-password"
                    class="body-2"
                    @keyup.enter="loginMethod"
                  >
                    <template #prepend-inner>
                      <v-icon small class="pt-1 pr-2">fas fa-key</v-icon>
                    </template>
                  </v-text-field>
                </v-form>
                <div class="d-flex align-center justify-space-between">
                  <v-checkbox :label="$t('login.rememberMe')" v-model="checkbox_remember_me" />
                  <a @click="forgotPassword">{{$t('login.forgotPassword')}}</a>
                  <v-btn color="primary"
                    @click="loginMethod"
                    :loading="loading"
                    :disabled="loading"
                  >
                    {{ $t('login.signInButton') }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card>
          <v-row class="justify-center" align="end">
            <v-card hover class="d-flex align-end mt-16 pt-16 display: fixed; bottom: 0;" color="transparent" elevation="0">
              <v-card-actions class="position: absolute; mt-16 pt-16">
                <v-card-text class="white--text text-center mt-13 pt-13 ">
                  <!-- <a class="white--text" style="text-decoration: none" :href="'https://it-enterprise.com/'">{{ new Date().getFullYear() }} Powered by It-enterprise</a> -->
                </v-card-text>
              </v-card-actions>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'LoginPage',
  watch: {
    isUserAuthenticated(val) {
      if (val) {
        this.$routerCore.GoToHomePage()
      }
    }
  },
  methods: {
    forgotPassword() {
      var locale = this.$i18n.locale || 'ru'
      var forgotePasswordUrl = `${window.appConfig.SiteUrl}/webparts/?id=LOGIN_REQUESTRECOVERPASSWORD&devexpress_theme=moderno&itLanguage=${locale}`
      window.open(forgotePasswordUrl)
    },
    async loginMethod () {
      if (!this.login || !this.password) {
        this.$store.commit('SET_ERROR', {text: this.$t('login.signInFormIsEmpty')})
        return
      }

      this.$authCore.SignIn({
        email: this.login,
        password: this.password,
        keepSigned: this.checkbox_remember_me
      })
    }
  },
  computed: {
    needToResize() {
      if (
        this.$vuetify.breakpoint.name == 'xl' ||
        this.$vuetify.breakpoint.name == 'lg' ||
        this.$vuetify.breakpoint.name == 'md'
      ) {
        return false
      }
      return true
    },
    isUserAuthenticated() {
      return this.$authCore.isAuthenticated
    },
    loading() {
      return this.$store.getters.getProcessing
    }
  },
  mounted() {
    if (this.$authCore.isAuthenticated) {
      this.$routerCore.GoToHomePage()
    }
  },
  data: () => ({
    login: '',
    password: '',
    checkbox_remember_me: false,
    glFirmLogoImg: process.env.VUE_APP_BASE_PATH + window.appConfig.GlFirmLogoImg,
    loginDopText: window.appConfig.LoginDopText.split('\n')
  }),
}
</script>

<style>
.link-style {
  text-decoration: none;
}
.card-action-container {
  justify-content: center;
}
.login-form-container {
  padding-top: 50px;
}
</style>